import { Link } from "react-router-dom";
import { categories, siteConfig } from "@/mocks/categories";

const navColumns = [
  {
    title: "Categories",
    items: categories.slice(0, 7),
  },
  {
    title: "More Categories",
    items: categories.slice(7),
  },
  {
    title: "Quick Links",
    items: [
      { name: "GTBuy Sheet Guide", url: "/article/gtbuy-spreadsheet-guide", internal: true },
      { name: "Visit Main Store", url: siteConfig.mainSiteUrl, internal: false },
      { name: "All Categories", url: "#categories", internal: true },
      { name: "About GTBuy", url: "#about", internal: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
                <span className="text-xl font-bold font-[family-name:var(--font-heading)]">
                  GTBuy
                </span>
                <span className="text-sm text-background-300 font-[family-name:var(--font-body)]">
                  Spreadsheet
                </span>
              </Link>
              <p className="text-sm text-background-300 leading-relaxed mb-6">
                The smartest way to compare products and make data-driven shopping decisions.
              </p>
              <p className="text-sm text-background-400 font-[family-name:var(--font-heading)] italic">
                &copy; {new Date().getFullYear()} GTBuy Sheet. All rights reserved.
              </p>
            </div>

            {navColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold text-background-100 mb-4 font-[family-name:var(--font-label)] uppercase tracking-wider">
                  {col.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {col.items.map((item) => {
                    if ("internal" in item && item.internal) {
                      return (
                        <li key={item.name}>
                          <Link
                            to={item.url}
                            className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                          >
                            {item.name}
                          </Link>
                        </li>
                      );
                    }
                    return (
                      <li key={"name" in item ? item.name : (item as typeof categories[0]).seq}>
                        <a
                          href={"url" in item ? item.url : (item as typeof categories[0]).url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                        >
                          {"name" in item ? item.name : (item as typeof categories[0]).name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-300/20 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              This site provides informational comparisons only. All product purchases are completed on the main platform.
            </p>
            <div className="flex items-center gap-4">
              <a
                href={siteConfig.mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-300 hover:text-background-100 transition-colors underline cursor-pointer"
              >
                KASpreadsheet
              </a>
              <Link
                to="/article/gtbuy-spreadsheet-guide"
                className="text-xs text-background-300 hover:text-background-100 transition-colors underline cursor-pointer"
              >
                Guide
              </Link>
              <Link
                to="/"
                className="text-xs text-background-300 hover:text-background-100 transition-colors underline cursor-pointer"
              >
                Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}